const vehicleTypeOptions = [
    { id: "automobile", label: "Automobile" },
    { id: "motorcycle", label: "Motorcycle" },
    { id: "atv", label: "ATV" },
    { id: "watercraft", label: "Watercraft" },
    { id: "jet_sky", label: "Jet Ski" },
    { id: "boat", label: "Boat" },
    { id: "trailers", label: "Trailers" },
    { id: "mobile_home", label: "Mobile Home" },
    { id: "emergency_equipment", label: "Emergency Equipment" },
    { id: "industrial_equipment", label: "Industrial Equipment" },
    { id: "truck", label: "Truck" },
    { id: "bus", label: "Bus" },
    { id: "other", label: "Other" },
  ];
  
  // API key for vehicle type
  const vehicleTypeAPIKey = "vehicle_type"; 
  
  // Label for vehicle type
  const vehicleTypeLabel = "Vehicle Type";
  
  export { vehicleTypeOptions, vehicleTypeAPIKey, vehicleTypeLabel };
  